import { render, staticRenderFns } from "./GenericAwardCard.vue?vue&type=template&id=7fe37929&scoped=true"
import script from "./GenericAwardCard.vue?vue&type=script&lang=js"
export * from "./GenericAwardCard.vue?vue&type=script&lang=js"
import style0 from "./GenericAwardCard.vue?vue&type=style&index=0&id=7fe37929&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe37929",
  null
  
)

export default component.exports